<div class="flex items-center justify-center min-h-screen bg-gray-100">
  <div>
    @if (authService.isLoggedIn()) {
      <h1
        class="text-2xl font-bold text-center mb-6 text-gray-800"
        >
        {{ "LOGIN_SUCCESS" | translate }}
      </h1>
    }
    @if (userLoginFailed) {
      <h1
        class="text-2xl font-bold text-center mb-6 text-dc-red"
        >
        {{ "LOGIN_FAILED" | translate }}
      </h1>
    }
    @if (userLoginFailed) {
      <p>{{ "LOGIN_FAILED_MESSAGE" | translate }}</p>
    }
    <div class="text-center">
      @if (userLoginFailed) {
        <button
          type="button"
          (click)="goToLogin()"
          class="w-60 bg-dc-navy text-white py-2"
          >
          {{ "LOGIN_AGAIN" | translate }}
        </button>
      }
    </div>
  </div>
</div>
